// src/pages/CustomerSpecialPrice/components/CustomerSpecialPriceTable.js
import React from "react";
import { Table, Popconfirm, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { deleteCustomerSpecialPrice } from "../CustomerSpecialPriceThunk";
import { setEditForm } from "../CustomerSpecialPriceSlice";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useIsAdminUser } from "../../../lib/accessList";

const CustomerSpecialPriceTable = ({ data, loading, messageApi }) => {
  const dispatch = useDispatch();

  const authInfo = useSelector((state) => state.auth?.auth_info);

  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;

  const isAdminUser = useIsAdminUser();

  const handleDelete = (id) => {
    dispatch(deleteCustomerSpecialPrice(id)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Deleted successfully ✅");
      } else {
        messageApi.error("Failed to delete ❌");
      }
    });
  };

  const handleEdit = (record) => {
    dispatch(setEditForm(record)); // put record into redux slice
  };

  const columns = [
    {
      title: "No.",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Item",
      dataIndex: "item_name",
    },
    {
      title: "Customer / Group",
      dataIndex: "display_name",
    },
    {
      title: "Price",
      dataIndex: "price",
      render: (value) => Number(value).toFixed(2),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Button
            onClick={() => handleEdit(record)}
            type="link"
            disabled={!(isAdminUser || canEdit)}
            icon={<EditOutlined />}
          />
          <Popconfirm
            title="Are you sure delete this?"
            disabled={!(isAdminUser || canDelete)}
            onConfirm={() => handleDelete(record.id)}
          >
            <Button
              style={{
                color: (isAdminUser || canDelete) ? "red" : "#ccc",
                marginLeft: "10px"
              }}
              disabled={!(isAdminUser || canDelete)}
              type="link"
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={{ pageSize: 10 }}
      scroll={{ x: "max-content" }}
    />
  );
};

export default CustomerSpecialPriceTable;
